import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/home/Home";
import SchemesServices from './components/schemes/SchemesServices';
import CentralSchemes from './components/schemes/CentralSchemes';
import StateSchemes from './components/schemes/StateSchemes';
import Scheme from './components/schemes/Scheme';
import Eligibility from './components/eligibility/Eligibility';
import Helplines from './components/helplines/Helplines';
import States from './components/schemes/States';
import ImportantPortals from './components/important-portals/ImportantPortals';
import ImportantPortal from './components/important-portals/ImportantPortal';
import ImportantDocuments from './components/important-documents/ImportantDocuments';
import ImportantDocument from './components/important-documents/ImportantDocument';
import SchemeAnnouncements from './components/scheme-announcements/SchemeAnnouncements';
import EntrepreneurshipDevelopement from './components/entrepreneurship-developement/EntrepreneurshipDevelopement';
import EligibilitySchemes from './components/eligibility/EligibilitySchemes';
import Page from './components/pages/Page';
import BusinessPlans from './components/entrepreneurship-developement/BusinessPlans';
import OrganizationRegistrations from './components/entrepreneurship-developement/organization-registrations/OrganizationRegistrations';
import OrganizationRegistration from './components/entrepreneurship-developement/organization-registrations/OrganizationRegistration';

import LegalRegistrations from './components/entrepreneurship-developement/legal-registrations/LegalRegistrations';
import LegalRegistration from './components/entrepreneurship-developement/legal-registrations/LegalRegistration';

import ArtificialIntelligence from './components/entrepreneurship-developement/artificialIntelligence/ArtificialIntelligence';
import Marketing from './components/entrepreneurship-developement/marketing/Marketing';
import BusinessRelatedSchemes from './components/entrepreneurship-developement/business-related-schemes/BusinessRelatedSchemes';
import BusinessRelatedScheme from './components/entrepreneurship-developement/business-related-schemes/BusinessRelatedScheme';

import ExploreQuizzes from './components/quizzes/ExploreQuizzes';
import TakeQuiz from './components/quizzes/TakeQuiz';
import QuizResult from './components/quizzes/QuizResult';

function App() {
  return (
    <>
      <Router>
        <div className="App">
          <Header/>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/home" exact element={<Home />} />
            <Route path="/quizzes" exact element={<ExploreQuizzes />} />
            <Route path="/quiz/:slug/:encoded_id" exact element={<TakeQuiz />} />
            <Route path="/quiz/:slug/:encoded_id/result" exact element={<QuizResult />} />
            <Route path="/schemes-and-services/:scheme_type" exact element={<SchemesServices />} />
            <Route path="/schemes/central/:category" exact element={<CentralSchemes />} />
            <Route path="/schemes/map" exact element={<States />} />
            <Route path="/schemes/map/state/:state/:name" exact element={<StateSchemes />} />
            <Route path="/scheme/:id" exact element={<Scheme />} />
            <Route path="/eligibility" exact element={<Eligibility />} />
            <Route path="/eligibility/schemes" exact element={<EligibilitySchemes />} />
            <Route path="/helplines" exact element={<Helplines />} />
            <Route path="/scheme-announcements" exact element={<SchemeAnnouncements />} />
            <Route path="/important-portals" exact element={<ImportantPortals />} />
            <Route path="/important-portal/:id" exact element={<ImportantPortal />} />
            <Route path="/important-documents" exact element={<ImportantDocuments />} />
            <Route path="/important-document/:id" exact element={<ImportantDocument />} />
            <Route path="/entrepreneurship-developement" exact element={<EntrepreneurshipDevelopement />} />
            <Route path="/entrepreneurship-developement/business-plans" exact element={<BusinessPlans />} />
            <Route path="/entrepreneurship-developement/organization-registrations" exact element={<OrganizationRegistrations />} />
            <Route path="/entrepreneurship-developement/organization-registration/:id" exact element={<OrganizationRegistration />} />

            <Route path="/entrepreneurship-developement/legal-registrations" exact element={<LegalRegistrations />} />
            <Route path="/entrepreneurship-developement/legal-registration/:id" exact element={<LegalRegistration />} />

            <Route path="/entrepreneurship-developement/artificial-intelligence" exact element={<ArtificialIntelligence />} />
            <Route path="/entrepreneurship-developement/marketing" exact element={<Marketing />} />

            <Route path="/entrepreneurship-developement/business-related-schemes" exact element={<BusinessRelatedSchemes/>} />
            <Route path="/entrepreneurship-developement/business-related-scheme/:id" exact element={<BusinessRelatedScheme/>} />

            <Route path="/page/:id" exact element={<Page />} />
          </Routes>
          <Footer />
          <ToastContainer />
        </div>
      </Router>
    </>
  );
}

export default App;
